import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CustomContentDialogData, ModalActionModel } from '@core/models/dialogs/dialog-data.model';
import { CustomContentDialogResult } from '@core/models/dialogs/dialog-results.model';

@Component({
  selector: 'epod-custom-content-popup',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, CommonModule],
  templateUrl: './epod-custom-content-popup.component.html',
  styleUrl: './epod-custom-content-popup.component.scss'
})
export class EpodCustomContentPopupComponent {
  private readonly _dialogRef = inject(MatDialogRef<EpodCustomContentPopupComponent, CustomContentDialogResult>);

  contentContext = {};
  constructor(@Inject(MAT_DIALOG_DATA) public readonly dialogData: CustomContentDialogData) {
    this.contentContext = { $implicit: dialogData.context };
  }

  actionButtonClick(action: ModalActionModel): void {
    this._dialogRef.close({ actionId: action.actionId } as CustomContentDialogResult);
  }

  cancelButtonClick(): void {
    this._dialogRef.close({ actionId: '' } as CustomContentDialogResult);
  }
}
